/**
 * Add an item to the right category, or update an existing item.
 *
 * @param {Array} items
 *   An array of existing items.
 * @param {object} item
 *   The item to add or update.
 *
 * @return {Array}
 *   The new items.
 */
export const updateItems = (items = [], item) => {
    const newItems = items.slice();
    // Check if an item should be updated.
    let updated = false;
    newItems.forEach((entity, index) => {
        if (entity.id === item.id) {
            newItems[index] = item;
            updated = true;
        }
    });
    // If no items was updated, add the item to the list.
    if (!updated) {
        newItems.push(item);
    }
    return newItems;
};
/**
 * Remove an item.
 *
 * @param {Array} items
 *   The items to remove from.
 * @param {integer} id
 *   The id of the item to remove.
 *
 * @return {Array}
 *   The new items.
 */
export const removeItem = (items = [], id) => {
    const newItems = items.slice();
    newItems.forEach((item, index) => {
        if (item.id === id) {
            newItems.splice(index, 1);
        }
    });
    return newItems;
};
/**
 * The reducer.
 *
 * @param {object} state
 *   The state object.
 * @param {object} action
 *   The action object.
 *
 * @return {object}
 *   A new state.
 */
export default (state = {}, action) => {
    switch (action.type) {
        case 'VALUES_SAVING': {
            return Object.assign(Object.assign({}, state), { isSaving: true, saveCompleted: false });
        }
        case 'VALUES_SAVED': {
            const newState = Object.assign(Object.assign({}, state), { items: updateItems(state.items, action.item), isSaving: false, saveCompleted: true });
            // Make sure the item to edit removed from state.
            delete newState.itemToEdit;
            return newState;
        }
        case 'APPLICATION_ERROR': {
            return Object.assign(Object.assign({}, state), { isSaving: false });
        }
        case 'VALUES_RECEIVED': {
            return Object.assign(Object.assign({}, state), { items: action.items, isLoading: false });
        }
        case 'VALUES_DELETING': {
            return Object.assign(Object.assign({}, state), { currentDeleting: action.itemId });
        }
        case 'VALUES_DELETED': {
            return Object.assign(Object.assign({}, state), { items: removeItem(state.items, action.itemId), currentDeleting: false });
        }
        case 'VALUES_NOT_DELETED': {
            return Object.assign(Object.assign({}, state), { currentDeleting: false });
        }
        case 'VALUES_TOGGLE_FOR_SHARE': {
            // If the id already exists in the list, remove it.
            let addForSharing = true;
            const itemsForShare = state.itemsForShare ? state.itemsForShare.slice() : [];
            itemsForShare.forEach((item, index) => {
                if (item === action.itemId) {
                    itemsForShare.splice(index, 1);
                    addForSharing = false;
                }
            });
            // Add the newly saved items to the items on the state, if it was not just removed
            if (addForSharing) {
                itemsForShare.push(action.itemId);
            }
            return Object.assign(Object.assign({}, state), { itemsForShare });
        }
        case 'VALUES_RESET_SHARE': {
            return Object.assign(Object.assign({}, state), { itemsForShare: [] });
        }
        case 'VALUES_EDIT': {
            const { item } = action;
            const newState = Object.assign({}, state);
            if (item) {
                newState.itemToEdit = item;
            }
            else {
                delete newState.itemToEdit;
            }
            return newState;
        }
        default: {
            return state;
        }
    }
};
